import React from "react";
import { QRCode } from "antd";

function QrCodeTest() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "90vh",
        gap: "40px",
      }}
    >
      <QRCode
        errorLevel="H"
        // value="https://demo.riv-tech.co.kr/eland/app/checkin?resourceId=20250318000003"
        value="https://localhost:3000/app/checkin?id=2023051000086&type=pad"
        //icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
        //icon="c:\Users\hmkim\Desktop\neat.png"
        // icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
        // iconSize={10}
        // size={100}
      />
      <QRCode
        errorLevel="H"
        // value="https://demo.riv-tech.co.kr/eland/app/checkin?resourceId=20250318000003"
        value="https://localhost:3000/app/checkin?id=20250318000002"
        //icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
        //icon="c:\Users\hmkim\Desktop\neat.png"
        // icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
        // iconSize={10}
        // size={100}
      />
      <QRCode
        errorLevel="H"
        // value="https://demo.riv-tech.co.kr/eland/app/checkin?resourceId=20250318000003"
        value="https://localhost:3000/app/checkin?id=20250318000003"
        //icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
        //icon="c:\Users\hmkim\Desktop\neat.png"
        // icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
        // iconSize={10}
        // size={100}
      />
    </div>
  );
}

export default QrCodeTest;
